import React, { useState, useEffect, useContext } from "react";

import { ActionPointLinkKind } from "../utils";
import InternalLink from "./BrowserView/InternalLink";
import ExternalLink from "./BrowserView/ExternalLink";
import ImageLink from "./BrowserView/ImageLink";
import ModalLink from "./BrowserView/ModalLink";
import DocumentLink from "./BrowserView/DocumentLink";

import ClickStreamKit from "../../../data/ClickStreamKit";
import { UserContext } from "../../../contexts/UserContext";
import Router from "next/router";
import InternalLinkMobile from "./MobileView/InternalLink";
import DocumentLinkMobile from "./MobileView/DocumentLink";
import ExternalLinkMobile from "./MobileView/ExternalLink";
import ModalLinkMobile from "./MobileView/ModalLink";
import ImageLinkMobile from "./MobileView/ImageLink";

import { isMobileOrTablet } from "../../Views/MobileClassRenderer";

export default function ActionPointRenderer({ children, ...props }) {
  const {
    id,
    page,
    title,
    description,
    top,
    left,
    iconKind,
    linkKind,
    linkDocument,
    linkExternal,
    linkInternal,
    linkImage,
    getDocumentFileName,
    getImageFileName,
    tabindex,
    linkVideoIframe,
    backgroundColor,
  } = props;

  const { me } = useContext(UserContext);

  const [modalIsOpen, setModalIsOpen] = useState(false);

  function createNonInternalStream() {
    const event = Router.query.event;
    const url = `/${event}/actionpoint-${props.id}`;
    if (url && event)
      clickStreamKit
        .createStream(event, url)
        .catch((errors) => console.log(""));
  }

  const clickStreamKit = new ClickStreamKit();

  useEffect(() => {
    if (modalIsOpen) {
      const url = linkDocument;
      const event = Router.query.event;
      clickStreamKit
        .createStream(event, url)
        .catch((errors) => console.log(""));
    }
  }, [modalIsOpen]);

  const renderInternal = () => {
    return (
      <>
        {renderLinkByView(
          <InternalLink
            id={id}
            linkInternal={linkInternal}
            tabindex={tabindex}
            iconKind={iconKind}
            left={left}
            top={top}
            linkKind={linkKind}
            title={title}
            backgroundColor={backgroundColor}
          />,
          <InternalLinkMobile id={id} linkInternal={linkInternal}>
            {children}
          </InternalLinkMobile>
        )}
      </>
    );
  };

  const renderLinkByView = (desktop, mobile) => {
    return isMobileOrTablet() ? mobile : desktop;
  };

  if (linkKind === ActionPointLinkKind.INTERNAL_PAGE && linkInternal) {
    if (linkInternal.includeEventUserGroups.length > 0) {
      const userGroupId = me?.group?.id;
      const pageGroupsInUserGroup = linkInternal.includeEventUserGroups.filter(
        (item) => {
          return item.id === userGroupId;
        }
      );
      if (pageGroupsInUserGroup.length > 0) {
        return <>{renderInternal()}</>;
      } else {
        return <></>;
      }
    }
    return <>{renderInternal()}</>;
  }
  if (linkKind === ActionPointLinkKind.EXTERNAL_PAGE) {
    return (
      <>
        {renderLinkByView(
          <ExternalLink
            id={id}
            title={title}
            iconKind={iconKind}
            createNonInternalStream={createNonInternalStream}
            linkExternal={linkExternal}
            tabindex={tabindex}
            left={left}
            top={top}
            linkKind={linkKind}
            backgroundColor={backgroundColor}
          />,
          <ExternalLinkMobile
            id={id}
            title={title}
            iconKind={iconKind}
            createNonInternalStream={createNonInternalStream}
            linkExternal={linkExternal}
            tabindex={tabindex}
            linkKind={linkKind}
          >
            {children}
          </ExternalLinkMobile>
        )}
      </>
    );
  }
  if (
    linkKind === ActionPointLinkKind.MODAL ||
    linkKind === ActionPointLinkKind.VIDEO
  ) {
    return (
      <>
        {renderLinkByView(
          <ModalLink
            id={id}
            linkInternal={linkInternal}
            tabindex={tabindex}
            left={left}
            top={top}
            iconKind={iconKind}
            description={description}
            createNonInternalStream={createNonInternalStream}
            linkKind={linkKind}
            linkVideoIframe={linkVideoIframe}
            title={title}
            backgroundColor={backgroundColor}
          />,
          <ModalLinkMobile
            id={id}
            linkInternal={linkInternal}
            tabindex={tabindex}
            description={description}
            createNonInternalStream={createNonInternalStream}
            linkKind={linkKind}
            linkVideoIframe={linkVideoIframe}
            title={title}
          >
            {children}
          </ModalLinkMobile>
        )}
      </>
    );
  }
  if (linkKind === ActionPointLinkKind.DOCUMENT) {
    return (
      <>
        {renderLinkByView(
          <DocumentLink
            id={id}
            title={title}
            setModalIsOpen={setModalIsOpen}
            modalIsOpen={modalIsOpen}
            getDocumentFileName={getDocumentFileName}
            createNonInternalStream={createNonInternalStream}
            linkDocument={linkDocument}
            tabindex={tabindex}
            left={left}
            top={top}
            iconKind={iconKind}
            backgroundColor={backgroundColor}
          />,
          <DocumentLinkMobile
            id={id}
            setModalIsOpen={setModalIsOpen}
            modalIsOpen={modalIsOpen}
            getDocumentFileName={getDocumentFileName}
            createNonInternalStream={createNonInternalStream}
            linkDocument={linkDocument}
          >
            {children}
          </DocumentLinkMobile>
        )}
      </>
    );
  }
  if (linkKind === ActionPointLinkKind.IMAGE) {
    return (
      <>
        {renderLinkByView(
          <ImageLink
            id={id}
            createNonInternalStream={createNonInternalStream}
            setModalIsOpen={setModalIsOpen}
            modalIsOpen={modalIsOpen}
            linkImage={linkImage}
            tabindex={tabindex}
            left={left}
            top={top}
            iconKind={iconKind}
            title={title}
            backgroundColor={backgroundColor}
          />,
          <ImageLinkMobile
            id={id}
            createNonInternalStream={createNonInternalStream}
            setModalIsOpen={setModalIsOpen}
            modalIsOpen={modalIsOpen}
            linkImage={linkImage}
            tabindex={tabindex}
            title={title}
          >
            {children}
          </ImageLinkMobile>
        )}
      </>
    );
  }
  if (linkKind === ActionPointLinkKind.VIRTUAL_MEETING_ROOM) {
    return <>{renderInternal()}</>;
  }
  if (linkKind === ActionPointLinkKind.VIRTUAL_SPEED_NETWORKING) {
    return <>{renderInternal()}</>;
  }
  return null;
}
